// src/pages/ProjectsPage/ProjectsPage.jsx
import React from 'react';
import Cta from '../../components/sections/Cta/Cta';
import FeaturedServices from '../../components/sections/FeaturedServices/FeaturedServices';
import Gallery from '../../components/sections/Gallery/Gallery';
import BeforeAfter from '../../components/sections/BeforeAfter/BeforeAfter';
import DesignGallery from '../../components/sections/DesignGallery/DesignGallery';
import WhyChooseUs from '../../components/sections/WhyChooseUs/WhyChooseUs';
const ProjectsPage = () => {
    return (
        <>
        <Gallery />
        <BeforeAfter />
        <DesignGallery />
        <FeaturedServices />
        <WhyChooseUs />
            <Cta />
        </>
    );
};

export default ProjectsPage;